// Local Imports
import { Progress } from "components/ui";
import { ThemeLogo } from "components/theme";

// ----------------------------------------------------------------------

export function SplashScreen() {
  return (
    <div className="fixed grid h-full w-full place-content-center">
      <ThemeLogo size="large" className="size-28" />
      <Progress
        color="primary"
        isIndeterminate
        animationDuration="1s"
        className="mt-2 h-1"
      />
    </div>
  );
}
